import api from '@/shared/api/api';
import { NotifyFileUploadFinishedReq } from '@/shared/api/protocol-ts/api/core/svc_upload_pb';

export const notifyFileUploadFinishedRequest = async (
  request: NotifyFileUploadFinishedReq,
) => {
  const response = await api.storage.notifyFileUploadFinished(request);
  return response.UploadSession;
};
